import IMAGE_URL from '../assets/face.png';

const IMAGE_WIDTH = 663;
const IMAGE_HEIGHT = 941;

export {IMAGE_URL, IMAGE_WIDTH, IMAGE_HEIGHT};
